import React, { PureComponent } from 'react';
import { IPart, IBoard } from 'types';

// Components
import Form, { TextField, FileUploadField } from 'ui/form';
import AutoComplete from 'ui/form/auto-complete';
import Button from 'ui/button';
import { ICON_ADD } from 'icons';
import { PartForm, PartItem } from 'components/part';
import { Fade } from 'ui/transition';
import BoardParts from './board-parts';
import styles from './board-form.scss';
interface BoardFormProps {
  parts: IPart[];
  board?: IBoard;
  header?: string;
  onSave: (board: IBoard) => void;
  onCancel: () => void;
}

class BoardForm extends PureComponent<BoardFormProps> {
  state = {
    selectedParts: [],
    showNewPart: false,
    board: false
  };
  handleSave = (form: IBoard) => {
    const model = { ...this.props.board, ...form };
    if (this.state.parts) model.parts = this.state.parts;
    this.props.onSave(model);
  };

  handleImageSelect = img => {};

  render() {
    const { header, board = {}, onCancel } = this.props;
    const { parts } = this.state;
    return (
      <div>
        <Form className="row" noButtons onSubmit={this.handleSave}>
          <FileUploadField
            name="image"
            className={styles.image}
            dir="board"
            value={board.image}
            onChange={this.handleImageSelect}
          />
          <div className="flex margin column v-center">
            {header && <h2>{header}</h2>}
            <TextField name="name" label="Board name" />
            <TextField name="description" label="Board description" multiline />
            <div className="row h-end">
              <Button className="tiny-margin" flat="Cancel" onClick={onCancel} />
              <Button className="tiny-margin" raised="Save" type="submit" />
            </div>
          </div>
        </Form>
        <div className="padding sub-card">
          <h2 className="tiny-margin">Board parts</h2>
          <BoardParts
            selected={parts || board.parts || []}
            onChange={parts => this.setState({ parts })}
          />
        </div>
      </div>
    );
  }
}

export default BoardForm;
